import { requiredString } from '@wyz/utils';
import { z } from 'zod';

export const S2S_BUSINESS_RULE_PARAMETER_TYPES = [
  'string',
  'int',
  'float',
  'bool',
] as const;

export const S2S_BUSINESS_RULE_CONSTRAINT_TYPES = [
  'POSITIVE',
  'POSITIVE_OR_ZERO',
  'MIN',
  'MAX',
  'RANGE',
  'CHOICE',
  'NOT_BLANK',
] as const;

const labelFormSchema = z.object({
  i18nKey: requiredString,
  defaultValue: requiredString,
});

const parameterConstraintFormSchema = z.object({
  type: z.enum(S2S_BUSINESS_RULE_CONSTRAINT_TYPES),
  options: z.array(
    z.object({
      key: requiredString,
      value: z.unknown(),
    }),
  ),
});

const parameterConstraintPayloadSchema = z.object({
  type: z.enum(S2S_BUSINESS_RULE_CONSTRAINT_TYPES),
  options: z.record(z.string(), z.unknown()),
});

const parameterDefinitionFormSchema = z
  .object({
    key: z.string(),
    i18nKey: requiredString,
    type: z.enum(S2S_BUSINESS_RULE_PARAMETER_TYPES),
    defaultValue: z.string().nullable(),
    constraints: z.array(parameterConstraintFormSchema),
  })
  .superRefine((pd, ctx) => {
    const value = pd.defaultValue;
    if (value === null || value === '') {
      return;
    }
    switch (pd.type) {
      case 'bool':
        if (value !== 'true' && value !== 'false') {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['defaultValue'],
            message:
              'app.s2s_business_rule.form.validation.default_value_type_mismatch',
          });
        }
        break;
      case 'int':
      case 'float': {
        const num = Number(value);
        const valid =
          pd.type === 'float' ? Number.isFinite(num) : Number.isInteger(num);
        if (!valid) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['defaultValue'],
            message:
              'app.s2s_business_rule.form.validation.default_value_type_mismatch',
          });
        }
        break;
      }
      case 'string':
        break;
    }
  });

export const s2sBusinessRuleFormSchema = z.object({
  code: z.string(),
  name: labelFormSchema,
  description: labelFormSchema,
  parameterDefinitions: z.array(parameterDefinitionFormSchema),
});

const parameterDefinitionPayloadSchema = z.object({
  key: requiredString,
  i18nKey: requiredString,
  type: z.enum(S2S_BUSINESS_RULE_PARAMETER_TYPES),
  defaultValue: z.string().nullable(),
  constraints: z.array(parameterConstraintPayloadSchema),
});

export const s2sBusinessRulePayloadSchema = z.object({
  name: labelFormSchema,
  description: labelFormSchema,
  parameterDefinitions: z.array(parameterDefinitionPayloadSchema),
});

export const s2sBusinessRuleFilterQuerySchema = z.object({
  query: z.string().optional(),
});
